export default __webpack_public_path__ + "static/media/laporan-akun.6aaccf90.png";